import { gql } from '@apollo/client';

export const getUsersWhoReadArticleByArticleId = gql`
  query getUsersWhoReadArticleByArticleId($articleId: ID!, $authorId: ID!) {
    userArticleRelations(
      where: {
        article: { id: { equals: $articleId } }
        user: { id: { not: { equals: $authorId } }, deactivated: { equals: false } }
        relationType: { equals: read }
        percentReadTime: { gte: "0.5" }
      }
      orderBy: { timestamp: desc }
    ) {
      user {
        id
        name
        publicAddress
        username
        profileImage {
          id
          publicUrl
          publicUrlTransformed
          _meta {
            public_id
            height
            width
          }
        }
      }
      timestamp
    }
  }
`;
